import { Wordmark } from '../components/Wordmark'
import { ThemeToggle } from '../components/ThemeToggle'
import { OperatorSignIn } from './SignIn'

/**
 * What production shows before it launches.
 *
 * The deployment exists, is migrated, and is driven by the founders exactly
 * as a customer would drive it, and it must not take a document from anybody
 * else. The API answers everyone but an operator with "not open yet", and this
 * is that answer on screen: not an error, because nothing is wrong, and not
 * the sign-in page, because the ways in it offers are for the public.
 *
 * The operator form stays, collapsed, because it is how the founders get in:
 * a session opened with the service key passes the closed door, and the app
 * then renders as it will on launch day.
 */
export function NotOpen({ onSignedIn }: { onSignedIn: () => void }) {
  return (
    <div className="signin-wrap">
      <div id="not-open" className="card signin-card">
        <div className="signin-logo">
          <Wordmark />
        </div>
        <ThemeToggle />
        <h1>Not open yet</h1>
        <p className="small muted">docsdone is being set up and is not taking documents yet.</p>
        {/* A link rather than a button: on the plate an outlined button and
            the disabled operator submit beneath it are the same shape in
            nearly the same ink, and nothing said which one did anything. */}
        <p className="signin-back">
          <a className="btn-link" href="https://docsdone.co">
            Back to docsdone.co
          </a>
        </p>
        <details className="signin-operator">
          <summary className="small muted">Operator sign-in</summary>
          <div className="signin-operator-body">
            <OperatorSignIn onSignedIn={onSignedIn} />
          </div>
        </details>
      </div>
    </div>
  )
}
